module.exports = __webpack_public_path__ + "static/media/ico-arrow.e724b35a.svg";